(function (global) {
    'use strict';

    global.NewHomeSource = global.NewHomeSource || {};
    global.NewHomeSource.BrochureAnimationHandler = global.NewHomeSource.BrochureAnimationHandler || {};

    const BrochureAnimationHandler = {};

    let lottieLoadPromise = null;

    /**
     * Loads the Lottie animation into a specified container.
     * Returns a Promise that resolves with the animation instance or null on failure.
     *
     * @param {string} containerId - The ID of the container element.
     * @param {string} iconPath - The path to the Lottie animation JSON.
     * @returns {Promise<Object|null>} - A Promise resolving to the animation instance or null.
     */
    BrochureAnimationHandler.downloadLottieResources = function (containerId, iconPath) {
        const container = document.getElementById(containerId);

        if (!lottieLoadPromise) {
            const library = document.getElementById('lottieAnimation');

            lottieLoadPromise = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = library.value;
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });
        }

        if (typeof define === 'function' && define.amd) {
            require(['lottie'], (lottie) => {
                lottie.loadAnimation({
                    container: container,
                    path: iconPath,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    name: 'Download animation',
                })
            });
            return;
        }

        return lottieLoadPromise.then(() => {
            if (!container || !iconPath) return null;

            return bodymovin.loadAnimation({
                container: container,
                path: iconPath,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                name: 'Download animation',
            });
        }).catch(() => null);
    };

    global.NewHomeSource.BrochureAnimationHandler = BrochureAnimationHandler;

})(window);
